//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from '@/api'
export default {
  name: 'SecurityCode',
  // component properties
  props: {
    number: {
      type: Number,
      default: 4
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  // variables
  data () {
    return {
      value: '',
      isShow: false
    }
  },
  methods: {
    hideKeyboard () {
    // 输入完成隐藏键盘
      document.activeElement.blur() // ios隐藏键盘
      this.$refs.input.blur() // android隐藏键盘
    },
    handleSubmit () {
      this.isShow = false
      if (this.value.length === 4) {
        this.axios.get(api.camp.code, {params: {coding: this.value}}).then(response => {
          if (response.data.code === 1) {
            this.$router.push({
              name: 'camp_detail',
              params: {
                id: response.data.data.uuid
              }
            })
          } else {
            this.isShow = true
          }
        })
      }
      // this.$emit('input', this.value)
    },
    handleInput (e) {
      this.$refs.input.value = this.value
      if (this.value.length >= this.number) {
        this.hideKeyboard()
      }
      this.handleSubmit()
    },
    hide () {
      this.$emit('codeBtn', 'false')
      this.value = ''
    }
  },
  mounted () {
    // document.activeElement.focus() // ios隐藏键盘
    // this.$refs.input.focus() // android隐藏键盘
  },
  watch: {
    value (val) {
      var newStr = val.replace(/\s/g, '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
      this.value = newStr
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/camp-code/index.vue